// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createContext } from 'react';

export interface ErrorBoundaryState {
    correlationVector?: string;
    error?: any;
    errorInfo?: any;
    onDismiss?: () => void;
    onDismissBrowserWarningMessage: () => void;
    showBrowserWarningMessage: boolean;
}

export const initialErrorState: ErrorBoundaryState = {
    correlationVector: undefined,
    error: undefined,
    errorInfo: undefined,
    onDismiss: () => {},
    onDismissBrowserWarningMessage: () => {},
    showBrowserWarningMessage: false,
};
  
export const ErrorBoundaryContext:React.Context<ErrorBoundaryState> = createContext(initialErrorState);
export default ErrorBoundaryContext;
